<template>
  <div>
    <v-card-text :ref="attribute.id + attribute.name.toLowerCase()" class="pa-0 pb-2" v-for="(attribute, indexAttr) in form.product.attributes" :key="attribute.id">
      <div v-if="form.product.attributes && hasAvailableForSale(attribute.values)">
        <v-list-item two-line class="primary white--text mb-2">
          <v-list-item-content>
            <v-list-item-title class="attribute-title">
              <span class="text-overline font-weight-bold">{{attribute.name}}</span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="configs.enable_order" class="white--text attribute-subtitle"
                                  v-text="captionAttrText(attribute)" />
            <v-list-item-subtitle v-if="configs.enable_order && attribute.charge_from" class="white--text attribute-subtitle"
                                  v-text="chargeFromText(attribute.charge_from)" />
            <v-list-item-subtitle v-if="configs.enable_order" class="white--text attribute-subtitle"
                                  v-text="howToCalculateText(attribute.how_to_calculate)" />
          </v-list-item-content>
          <v-list-item-action v-if="!attribute.flg_optional">
            <v-chip
                color="secondary"
                text-color="white"
                class="font-weight-bold"
                label
            >
              Obrigatório
            </v-chip>
          </v-list-item-action>
        </v-list-item>

        <v-list-item
            v-for="value in attribute.values"
            v-if="value.available_for_sale"
            :key="value.id"
            class="min-h-0 mb-3"
        >
          <v-list-item-content class="d-flex pa-0 col-7"
                               @click="showImage(value.value.image, value.name, value.unitary_value, value.value.description)"
                               :class="{'disable-option': plusDisabled(attribute.id_product_attribute)}">
            <p class="font-weight-medium">{{value.name}}</p>
            <p class="text-caption">{{value.value.description}}</p>
            <p class="ma-0 font-weight-medium primary--text text-price" v-text="formatMoney(value.unitary_value)" />
          </v-list-item-content>

          <v-list-item-content class="pa-0 col-5 justify-end">
            <div class="col-5 pa-0" v-if="configs.show_image" @click="showImage(value.value.image, value.name, value.unitary_value, value.value.description)">
              <v-img
                  v-if="value.value.image"
                  height="60"
                  width="60"
                  class="rounded-lg"
                  :src="value.value.image" />
            </div>
            <div class="col-7 pa-0 text-center" v-if="configs.enable_order">
              <v-btn
                  color="primary"
                  icon
                  tile
                  x-small
                  @click="minus(attribute, value)"
              ><v-icon>$minus</v-icon></v-btn>
              <span class="mx-2" v-text="qtdFromAttrValue(attribute, value.id_product_attribute_value)"></span>
              <v-btn
                  color="primary"
                  icon
                  tile
                  x-small
                  :disabled="plusDisabled(attribute.id_product_attribute)"
                  @click="plus(attribute, value)"
              ><v-icon>$plus</v-icon></v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-card-text>

    <div v-if="form.product.additionals">
      <v-card-text class="pa-0 pb-2">
        <v-list-item two-line class="primary white--text mb-2">
          <v-list-item-content>
            <v-list-item-title>
              <span class="text-overline font-weight-bold">Adicionais</span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="configs.enable_order" class="white--text text-caption"
                                  v-text="captionAdditionalText()" />

            <v-list-item-subtitle v-if="form.product.charge_additionals_from > 0"
                                  class="white--text text-caption"
                                  v-text="additionalChargeFromText()" />
          </v-list-item-content>
          <v-list-item-action v-if="form.product.min_additionals > 0">
            <v-chip
                color="secondary"
                text-color="white"
                class="font-weight-bold"
                label
            >
              Obrigatório
            </v-chip>
          </v-list-item-action>
        </v-list-item>

        <v-list-item
            v-for="(additional, indexAdd) in form.product.additionals"
            :key="additional.id"
            class="min-h-0"
        >
          <v-list-item-content class="d-flex pa-0 col-7"
                               :class="{'disable-option': !form.plus_additionals_enabled}"
                               @click="showImage(additional.image, additional.name, additional.unitary_value)">
            <p class="font-weight-medium" v-text="additional.name"></p>
            <v-list-item-title v-text="`(max: ${additional.max})`" class="text-caption" />
            <p class="ma-0 font-weight-medium primary--text text-price" v-text="formatMoney(additional.unitary_value)" />
          </v-list-item-content>

          <v-list-item-content class="pa-0 mb-2 col-5 justify-end">
            <div class="col-5 pa-0" v-if="configs.show_image" @click="showImage(additional.image, additional.name, additional.unitary_value)">
              <v-img
                  v-if="additional.image"
                  height="60"
                  width="60"
                  class="rounded-lg"
                  @click="showImage(additional.image, additional.name, additional.unitary_value)"
                  :src="additional.image" />
            </div>
            <div class="col-7 pa-0 text-center" v-if="configs.enable_order">
              <v-btn
                  color="primary"
                  icon
                  tile
                  x-small
                  @click="minusAdditional(additional)"
              ><v-icon>$minus</v-icon></v-btn>
              <span class="mx-2" v-text="amountFromAdditional(additional)"></span>
              <v-btn
                  color="primary"
                  icon
                  tile
                  x-small
                  :disabled="!form.plus_additionals_enabled || amountFromAdditional(additional) >= additional.max"
                  @click="plusAdditional(additional)"
              ><v-icon>$plus</v-icon></v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </div>

    <div v-if="form.product.components && form.product.components.length">
      <v-card-text class="pa-0 pb-2">
        <v-list-item two-line class="primary white--text">
          <v-list-item-content>
            <v-list-item-title>
              <span class="text-overline font-weight-bold">Componentes</span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="isAutomaticProduction"
                                  class="white--text text-caption"
                                  v-text="`Selecione os componentes a serem REMOVIDOS`" />
          </v-list-item-content>
        </v-list-item>

        <v-list-item
            v-for="component in form.product.components"
            :key="component.id"
            class="min-h-0"
        >
          <v-list-item-content class="d-flex pa-0 col-8"
                               @click="showImage(component.component.image, component.component.name, false, component.component.description)"
                               :class="{'col-10': !isAutomaticProduction}">
            <v-list-item-title v-text="component.component.name"></v-list-item-title>
            <v-list-item-title v-text="component.component.description" class="text-caption" />
          </v-list-item-content>

          <v-list-item-content class="px-0 col-2 justify-center" v-if="isAutomaticProduction && configs.enable_order">
            <v-checkbox class="pa-0 ma-0" hide-details v-model="form.removedComponents" :value="component.component" />
          </v-list-item-content>

          <v-list-item-content class="px-0 col-2" v-if="configs.show_image"
                               @click="showImage(component.component.image, component.component.name, false, component.component.description)">
            <v-img
                height="45"
                width="45"
                class="mx-auto rounded-lg"
                :src="component.component.image"></v-img>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </div>

    <v-card-text class="py-0" v-if="configs.enable_order">
      <v-textarea
          v-model="form.observation[0]"
          auto-grow
          ref="observation"
          :maxlength="150"
          :counter="150"
          rows="2"
      >
        <template v-slot:label>
          <div>
            Observações <small>(opcional)</small>
          </div>
        </template>
      </v-textarea>
    </v-card-text>

    <v-dialog
        v-model="dialogImage"
    >
      <v-card>
        <v-card-title class="pl-3 pr-1 pt-1">
          <span class="text-h6">{{dataDialog.title}}</span>
        </v-card-title>

        <v-btn
            fab
            dark
            x-small
            color="primary"
            absolute
            style="top: -13px !important; right: -15px !important;"
            @click="dialogImage = false"
        >
          <v-icon dark>$close</v-icon>
        </v-btn>

        <v-card-text class="px-1" v-if="dataDialog.image">
          <v-img
              height="200"
              width="200"
              class="mx-auto rounded-lg"
              :src="dataDialog.image"></v-img>
        </v-card-text>
        <v-card-text class="text-justify text-center" v-if="dataDialog.description" v-text="dataDialog.description" />
        <v-card-text class="text-right primary--text font-weight-bold" v-if="dataDialog.price" v-text="formatMoney(dataDialog.price)" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "ConfigureProduct",
  props: {
    form: {
      required: true
    },
    type: {
      required: true
    }
  },
  data: () => ({
    howToCalculateTypes: {
      1: 'HIGHEST',
      2: 'AVERAGE',
      3: 'AVERAGE',
      4: 'CUMULATIVE'
    },
    canBeAddedToCart: false,
    dialogImage: false,
    dataDialog: {
      image: '',
      description: '',
      price: 0,
      title: ''
    }
  }),
  setup (props) {
    const configs = _config.functionalities.digitalmenu.configs

    return { configs }
  },
  mounted() {
    this.canBeAdded()
  },
  methods: {
    showImage (image, title, price = false, description = '') {
      this.dialogImage = true
      this.dataDialog = {image, title, price, description}
    },

    hasAvailableForSale (values) {
      return values.filter(value => value.available_for_sale).length > 0
    },
    chargeFromText (chargeFrom) {
      if (chargeFrom > 1) {
        return `Os ${chargeFrom} primeiros não serão cobrados.`
      }

      return `O primeiro não será cobrado.`
    },
    howToCalculateText (howToCalculate) {
      let types = {
        1: 'Maior Valor',
        2: 'Média',
        3: 'Média',
        4: 'Acumulativo'
      }

      return 'Tipo de cobrança: ' + types[howToCalculate]
    },
    captionAttrText (attribute) {
      let endText = `${attribute.multiple_n2} ${attribute.multiple_n2 > 1 ? 'opções' : 'opção'}`

      if (!attribute.flg_optional && attribute.multiple_n1 > 1) {
        return `(Escolha de ${attribute.multiple_n1} até ${endText})`
      }

      return `(Escolha até ${endText})`
    },
    qtdFromAttrValue (attribute, valueId) {
      return this.form.attributes.find(attr => attr.id === attribute.id_product_attribute)?.options.filter(option => option.id === valueId)?.length ?? 0
    },
    plusDisabled (attributeId) {
      return this.form.attributes.find(attribute => attribute.id === attributeId)?.plusDisabled
    },
    plus (attribute, value) {
      let formAttribute = this.form.attributes.find(attr => attr.id === attribute.id_product_attribute)

      if (!formAttribute) {
        let length = this.form.attributes.push({
          id: attribute.id_product_attribute,
          name: attribute.name,
          charge: this.howToCalculateTypes[attribute.how_to_calculate],
          charge_from: attribute.charge_from,
          options: []
        })

        formAttribute = this.form.attributes[length - 1]
      }

      formAttribute.options.push({
        id: value.id_product_attribute_value,
        name: value.name,
        unitary_value: parseFloat(value.unitary_value),
        removedComponents: []
      })

      //Controla a quantidade máxima
      if (formAttribute.options.length >= attribute.multiple_n2) {
        formAttribute.plusDisabled = true
        this.scrollMeTo(this.getNextAttribute(attribute.id))
      }

      this.calculateTotalValue()
    },
    minus (attribute, value) {
      let formAttribute = this.form.attributes.find(attr => attr.id === attribute.id_product_attribute)
      let indexToBeRemoved = formAttribute?.options.findLastIndex(vl => vl.id === value.id_product_attribute_value)

      if (indexToBeRemoved >= 0) {
        formAttribute.options.splice(indexToBeRemoved, 1)
        formAttribute.plusDisabled = false
      }

      if (formAttribute.options.length === 0) {
        let indexFormAttribute = this.form.attributes.findIndex(attr => attr.id === attribute.id_product_attribute)
        this.form.attributes.splice(indexFormAttribute, 1)
      }

      this.calculateTotalValue()
    },
    plusAdditional(additional) {
      if (this.form.plus_additionals_enabled) {
        this.form.additionals.push({
          id: additional.id,
          name: additional.name,
          total_value: additional.unitary_value,
          unitary_value: additional.unitary_value,
          amount: 1
        })
      }

      if (this.form.additionals.length >= this.form.product.max_additionals) {
        this.form.plus_additionals_enabled = false
      }

      this.calculateTotalValue()
    },
    minusAdditional(additional) {
      let index = this.form.additionals.findLastIndex(add => add.id === additional.id)
      if (index < 0) {
        return true
      }

      this.form.additionals.splice(index, 1)
      this.form.plus_additionals_enabled = true

      this.calculateTotalValue()
    },
    amountFromAdditional (additional) {
      return this.form.additionals.filter(add => add.id === additional.id)?.length ?? 0
    },
    captionAdditionalText () {
      if (this.form.product.max_additionals > 1 && this.form.product.min_additionals > 0) {
        return `Selecione entre ${this.form.product.min_additionals} e ${this.form.product.max_additionals} adicionais`
      }

      return `Selecione até ${this.form.product.max_additionals} ${this.form.product.max_additionals > 1 ? 'adicionais' : 'adicional'}`
    },
    additionalChargeFromText () {
      return `Será cobrado à partir de ${this.form.product.charge_additionals_from} ${this.form.product.charge_additionals_from > 1 ? 'itens' : 'item'}`
    },
    calculateTotalValue() {
      let value = this.form.base_value

      if (this.form.attributes) {
        Array.from(this.form.attributes).forEach(formAttribute => {
          let attribute = this.form.product.attributes.find(attr => attr.id_product_attribute === formAttribute.id)
          let formValuesSliced = formAttribute.options.slice(attribute.charge_from)

          //Maior valor
          if (attribute.how_to_calculate === 1) {
            value += _.max(formValuesSliced.map(value => value.unitary_value)) ?? 0
          }

          //Valor pela média ou proporcional à quantidade (basicamente os 2 tem a mesma função)
          if (attribute.how_to_calculate === 2 || attribute.how_to_calculate === 3) {
            let totalValueSelected = 0
            let totalQtdSelected = 0

            Array.from(formValuesSliced).forEach(value => {
              totalValueSelected += value.unitary_value
              totalQtdSelected += 1
            })

            if (totalQtdSelected > 0) {
              value += totalValueSelected / totalQtdSelected
            }
          }

          //Acumulativo
          if (attribute.how_to_calculate === 4) {
            Array.from(formValuesSliced).forEach(v => {
              value += v.unitary_value
            })
          }
        })
      }

      if (this.form.additionals) {
        value += _.sumBy(this.form.additionals.slice(this.form.product.charge_additionals_from), 'unitary_value')
      }

      this.canBeAdded()
      this.form.unitary_value = this.formatValue(value)
      this.form.total_value = this.formatValue(value * this.form.amount)

      if (this.enabledServiceTax && this.form.flg_charge_service_fee) {
        this.form.tax_value = this.formatValue(this.form.total_value * (this.configs.percent_tax / 100))
      }
    },

    canBeAdded () {
      this.form.canBeAddedToCart = true

      if (this.form.product.attributes) {
        //Pega apenas os atributos obrigatório e que possuem valores disponíveis para venda
        let productAttributes = this.form.product.attributes.filter(attribute =>
            !attribute.flg_optional && attribute.values.filter(value => value.available_for_sale).length > 0
        )

        Array.from(productAttributes).forEach(attribute => {
          let formAttribute = this.form.attributes.find(value => value.id === attribute.id_product_attribute)
          if (!formAttribute || attribute.multiple_n1 > formAttribute.options.length) {
            this.form.canBeAddedToCart = false
          }
        })
      }

      if (this.form.product.additionals) {
        if (this.form.additionals?.length < this.form.product.min_additionals) {
          this.form.canBeAddedToCart = false
        }
      }
    },

    getNextAttribute (attributeId) {
      const index = this.form.product.attributes.findIndex(attr => attr.id === attributeId)
      const nextAttribute = this.form.product.attributes[index + 1]
      return nextAttribute ? nextAttribute.id + nextAttribute.name.toLowerCase() : false
    },

    scrollMeTo(attributeName) {
      if (attributeName) {
        this.$nextTick(_ => {
          const parent = document.getElementById('card-configure-product')
          const top = this.$refs[attributeName][0].offsetTop

          parent.scrollTo({
            top: top + (this.typeCombo ? (this.configs.show_image ? 185 : 25) : -45),
            behavior: 'smooth'
          });
        })
      }
    }
  },
  computed: {
    typeCombo () {
      return this.type === 'combo'
    },
    isCombo () {
      return this.form.product.composition_type === 1
    },
    isAutomaticProduction () {
      return this.form.product.composition_type === 3
    },
    enabledServiceTax () {
      return this.configs.enable_service_tax && this.configs.percent_tax > 0
    },
  },
}
</script>

<style lang="scss">
  .text-price {
    font-size: 0.850em;
  }
  .disable-option {
    opacity: 0.4
  }
  .v-dialog {
    overflow: inherit !important;
  }
</style>